module.exports = __webpack_public_path__ + "static/media/moffi.df777ae7.png";